import FooterTapbarCart from './footer-tapbar-cart.vue';
import { createApp } from 'vue';

export const footerTapbarCart = () => {
	const element = document.querySelector('#footer-tapbar-cart');
	const { href } = element.dataset;
	
	const app = createApp(FooterTapbarCart, { href });
	app.use(window.app.pinia);
	app.mount(element);
};
